function Slide3() {
  return (
    <div className="flex flex-col w-[85vw]">
        <h1 className="text-xl text-center py-5">Skip queues & waiting</h1>
        <h2 className="text-center text-blue-800 underline"><a href="https://www.mhlab.ca/home-lab-visit/">Book a home visitation today!</a></h2>
    </div>
  )
}

export default Slide3